const shapeRSvg = "data:image/svg+xml,%3csvg%20width='12'%20height='12'%20viewBox='0%200%2012%2012'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%2012V0H0L12%2012Z'%20fill='%23994545'/%3e%3c/svg%3e";
export {
  shapeRSvg as default
};
//# sourceMappingURL=shape-r.svg.js.map
